import {
    FormAddress,
    FormInputGroup,
    FormSection,
    FormText,
    FormSelect,
} from 'components/form';
import { FormSelectOption } from 'components/form/types';
import { useFormState } from 'hooks/useFormState';
import { useSupplierGroups } from 'hooks/useSupplierGroups';
import { useEffect } from 'react';
import { SupplierGroup } from 'types';

export function CreateDeviceModalAddressSection() {
    const groups = useSupplierGroups();

    const getGroups = () => {
        const defaultOption: FormSelectOption = { name: 'None', value: '' };
        const groupOptions = groups?.map((group: SupplierGroup) => {
            return { value: group.name };
        });
        if (groupOptions) return [defaultOption, ...groupOptions];
        else return [defaultOption];
    };

    const formSectionTitle = 'Address';

    // Manage the submit button state
    const { setIsFormSubmitDisabled, currentFormSectionIndex, formSections } =
        useFormState();
    useEffect(() => {
        if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            setIsFormSubmitDisabled(false);
        }
    }, [setIsFormSubmitDisabled, currentFormSectionIndex, formSections]);

    return (
        <FormSection title={formSectionTitle}>
            <FormAddress field="address" />
            <FormInputGroup>
                <FormText field="customer_name" />
                <FormText field="name" label="Tank Name" />
            </FormInputGroup>
            <FormInputGroup>
                <FormSelect field="group" options={getGroups()} />
            </FormInputGroup>
        </FormSection>
    );
}
